import React from 'react';
import { apiHolder as api, apis, } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import get from 'lodash/get';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { isMac, openMailInWinow, isMainAccount, getMailFromMails, getCorpMessageIdsByMailItem, getMailListAccount, mailListSortByAccountToId, } from '@web-mail/util';
import { FLOLDER, MAIL_MENU_ITEM, TASK_MAIL_STATUS } from '../../../constant';
import MailTagMenu from '../../../../components/MailTag/Menu/Menu';
import { getShowByFolder, taskMailMenuShow } from '../util';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import MailEncoding from '@web-mail/components/MailEncoding';
import { getIn18Text } from 'api';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import { BianjiHuifu, TongyongHuifuquanbu } from '@sirius/icons';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const storeApi = api.api.getDataStoreApi();
const nimApi = api.api.requireLogicalApi('NIM');
const contactApi = api.api.requireLogicalApi('contactApi');
const isCorpMail = systemApi.getIsCorpMailMode();
const EXEMPTION_OF_REPLY_MAILIDS = 'EXEMPTION_OF_REPLY_MAILIDS';
const MAIL_EXPORT_LIMIT = 100;
const getOperMailId = (mail) => {
    const { entry: { id, threadMessageIds }, isThread = false, } = mail || { entry: {} };
    let mailId = id;
    if (isThread && threadMessageIds && threadMessageIds[0]) {
        mailId = threadMessageIds[0];
    }
    return mailId;
};
const permRecallMail = () => mailConfApi.getPermRecallMail();
const replyPreCheck = async (mail) => {
    var _a, _b, _c;
    const senderEmail = (_c = (_b = (_a = mail === null || mail === void 0 ? void 0 : mail.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName;
    const curMailId = mail === null || mail === void 0 ? void 0 : mail.id;
    const replyToArr = (mail === null || mail === void 0 ? void 0 : mail.headers) ? mail === null || mail === void 0 ? void 0 : mail.headers['Reply-To'] : [];
    if (replyToArr && replyToArr.length) {
        let isDiff = false;
        try {
            const replyToParsedEmail = mailApi.handleEmailListStringToParsedContent(replyToArr[0], { origin: [], parsed: [] });
            const senderParsedEmail = mailApi.handleEmailListStringToParsedContent(senderEmail, { origin: [], parsed: [] });
            if (replyToParsedEmail.parsed.length && senderParsedEmail.parsed.length) {
                isDiff = replyToParsedEmail.parsed[0].email !== senderParsedEmail.parsed[0].email;
            }
        }
        catch (e) {
            console.error('[Error reg]', e);
        }
        if (isDiff) {
            const res = await storeApi.get(EXEMPTION_OF_REPLY_MAILIDS);
            const { suc, data: mailIds } = res;
            const mailIdArr = mailIds ? mailIds.split(',') : [];
            if (suc) {
                if (mailIdArr === null || mailIdArr === void 0 ? void 0 : mailIdArr.includes(curMailId))
                    return true;
            }
            const content = (React.createElement("span", null,
                "\u539F\u90AE\u4EF6\u53D1\u9001\u5730\u5740\uFF1A",
                senderEmail,
                React.createElement("br", null),
                "\u56DE\u590D\u5730\u5740\uFF1A",
                replyToArr[0]));
            return new Promise(resolve => {
                SiriusModal.confirm({
                    title: getIn18Text('NINHUIFUDEDIZHYYJFSDZBYZ，QZYSB'),
                    content,
                    okText: '继续回复',
                    onOk: () => {
                        storeApi.put(EXEMPTION_OF_REPLY_MAILIDS, [...mailIdArr, curMailId].join(','));
                        resolve(true);
                    },
                    onCancel: () => resolve(false),
                });
            });
        }
    }
    return true;
};
const getShouldShowPrintByEmails = (mails) => {
    const mail = getMailFromMails(mails);
    if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
        return false;
    }
    const { isThread } = mail;
    return !isThread;
};
const handleMailPrint = async (mails, isPreview) => {
    const mail = getMailFromMails(mails);
    const { isThread, _account, isEncryptedMail } = mail;
    const bandExport = await mailConfApi.getAccountBanSetting(_account).then(res => res.ban_export_mail);
    if (bandExport) {
        message.warn(getIn18Text('MEIYOUDAYINQUANX，QLXGLY'));
        return;
    }
    const { id } = mail.entry;
    if (isEncryptedMail) {
        Toast.info({ content: getIn18Text('JIAMIYOUJIANZANBZCDY') });
        return;
    }
    eventApi.sendSysEvent({
        eventName: 'mailMenuOper',
        eventData: {
            mailId: id,
            isThread,
            isPreview: !!isPreview,
        },
        eventStrData: 'print',
        _account,
    });
};
const generateAcc = (mail) => {
    let { _account, mailFrom, isTpMail, mainAccount } = mail;
    if (isTpMail && mailFrom === 'relatedEmail')
        _account = mainAccount;
    return _account;
};
const DefaultMailMenuConfig = {
    [MAIL_MENU_ITEM.BACK]: {
        key: MAIL_MENU_ITEM.BACK,
        name: getIn18Text('FANHUI'),
        show: mails => {
            const mail = getMailFromMails(mails);
            return systemApi.isMainPage();
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { _account } = mail;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: mail,
                eventStrData: 'back',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.RE_EDIT]: {
        key: MAIL_MENU_ITEM.RE_EDIT,
        name: getIn18Text('ZHONGXINBIANJI'),
        icon: React.createElement(ReadListIcons.MailEditSvg_Cof, null),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return getShowByFolder(mail, [FLOLDER.DRAFT, FLOLDER.SENT]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { folder } = mail.entry;
            const { _account } = mail;
            return mailApi.doEditMail(getOperMailId(mail), { draft: folder === FLOLDER.DRAFT, _account });
        },
    },
    [MAIL_MENU_ITEM.REPLAY]: {
        key: MAIL_MENU_ITEM.REPLAY,
        name: getIn18Text('HUIFU'),
        icon: React.createElement(BianjiHuifu, null),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'subordinate' && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'relatedEmail') {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        onClick: async (mails) => {
            const mail = getMailFromMails(mails);
            const ckRes = await replyPreCheck(mail);
            if (!ckRes)
                return;
            const { owner, mailFrom, tpMailInfo, isTpMail } = mail;
            const { colleagueAccId, type, refId } = tpMailInfo || {};
            const _account = generateAcc(mail);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'replay' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            return mailApi
                .doReplayMail(getOperMailId(mail), false, undefined, undefined, _account, {
                owner,
                colleagueAccId,
                isTpMail,
                mailFrom,
                type,
                refId,
            })
                .then(res => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'replay' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
                return res;
            });
        },
    },
    [MAIL_MENU_ITEM.REPLAY_ALL]: {
        key: MAIL_MENU_ITEM.REPLAY_ALL,
        name: getIn18Text('HUIFUQUANBU'),
        icon: React.createElement(TongyongHuifuquanbu, null),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'subordinate' && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'relatedEmail') {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        onClick: async (mails) => {
            const mail = getMailFromMails(mails);
            const ckRes = await replyPreCheck(mail);
            if (!ckRes)
                return;
            const { mailFrom, owner, tpMailInfo, isTpMail } = mail;
            const { colleagueAccId, type, refId } = tpMailInfo || {};
            const _account = generateAcc(mail);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'replayAll' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            return mailApi
                .doReplayMail(getOperMailId(mail), true, undefined, undefined, _account, {
                owner,
                colleagueAccId,
                isTpMail,
                mailFrom,
                type,
                refId,
            })
                .then(res => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'replayAll' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
                return res;
            });
        },
    },
    [MAIL_MENU_ITEM.FORWARD]: {
        key: MAIL_MENU_ITEM.FORWARD,
        name: getIn18Text('ZHUANFA'),
        icon: React.createElement(ReadListIcons.TransmitSvg_Cof, null),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'subordinate' && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'relatedEmail') {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { owner, mailFrom, tpMailInfo, isTpMail } = mail;
            const { colleagueAccId, type, refId } = tpMailInfo || {};
            const _account = generateAcc(mail);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'forward' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            return mailApi
                .doForwardMail(getOperMailId(mail), {
                _account,
                owner,
                colleagueAccId,
                mailFrom,
                isTpMail,
                type,
                refId,
            })
                .then(res => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'forward' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
                return res;
            });
        },
    },
    [MAIL_MENU_ITEM.DELIVERY]: {
        key: MAIL_MENU_ITEM.DELIVERY,
        name: () => {
            var _a;
            return process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion) ? getIn18Text('FENFA') : getIn18Text('deliveryMail');
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            const userInfo = systemApi.getCurrentUser(mail === null || mail === void 0 ? void 0 : mail._account);
            const email = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || (mail === null || mail === void 0 ? void 0 : mail._account);
            return !(mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'biz' && !email.includes('@qq.com') && !email.includes('@foxmail.com');
        },
        onClick: mails => {
        },
    },
    [MAIL_MENU_ITEM.FORWARD_BY_ATTACH]: {
        key: MAIL_MENU_ITEM.FORWARD_BY_ATTACH,
        name: getIn18Text('ZUOWEIFUJIANZHUAN'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'subordinate' && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'relatedEmail') {
                return false;
            }
            if ((mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz')
                return false;
            if (isCorpMail)
                return false;
            const { isThread } = mail;
            return !isThread && !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        onClick: async (mails) => {
            const mailArr = Array.isArray(mails) ? mails : [mails];
            const mail = getMailFromMails(mails);
            const { owner, mailFrom, entry, tpMailInfo, isTpMail } = mail;
            const { colleagueAccId, refId, type } = tpMailInfo || {};
            const _account = generateAcc(mail);
            const totalSize = mailArr.reduce((total, mail) => {
                return total + ((mail === null || mail === void 0 ? void 0 : mail.size) || 0);
            }, 0);
            const mailLimit = mailConfApi.getMailLimit({ _account });
            if (totalSize > mailLimit.upload_total_size) {
                const curVersionId = await productAuthApi.asyncGetProductVersionId({ _account });
                if (curVersionId === 'free') {
                    eventApi.sendSysEvent({ eventName: 'mailMenuOper', eventStrData: 'freeVerionSizeOver' });
                }
                else {
                    message.error(getIn18Text('ZONGDAXIAOCHAOXIAN，WFZF'));
                }
                return;
            }
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'forwardAsAttach' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            const asAttachIds = mailArr.map((item) => item.entry.id);
            return mailApi
                .doForwardMailAsAttach(asAttachIds.join('&and&'), {
                asAttach: true,
                asAttachIds,
                _account,
                owner,
                colleagueAccId,
                title: (entry === null || entry === void 0 ? void 0 : entry.title) || '',
                mailFrom,
                isTpMail,
                type,
                refId,
            })
                .then(res => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'forwardAsAttach' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
                return res;
            });
        },
    },
    [MAIL_MENU_ITEM.REPLAY_ATTACH]: {
        key: MAIL_MENU_ITEM.REPLAY_ATTACH,
        name: getIn18Text('DAIFUJIANHUIFU11'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'subordinate' && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'relatedEmail') {
                return false;
            }
            if ((mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz')
                return false;
            const { isThread } = mail;
            const { attachment } = mail.entry;
            const isShowAttachBtn = attachment && attachment.some(attach => !attach.inlined && attach.fileType !== 'ics');
            return !!isShowAttachBtn && !(getShowByFolder(mail, [FLOLDER.DRAFT]) || isCorpMail || isThread);
        },
        onClick: async (mails) => {
            const mail = getMailFromMails(mails);
            const ckRes = await replyPreCheck(mail);
            if (!ckRes)
                return;
            const { mailFrom, owner, tpMailInfo = {}, isTpMail } = mail;
            const { type, refId, colleagueAccId, belongEmail } = tpMailInfo || {};
            const _account = generateAcc(mail);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'replyAttach' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            setTimeout(() => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'replyAttach' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
            }, 500);
            return mailApi.doReplayMailWithAttach(getOperMailId(mail), false, undefined, undefined, _account, {
                owner: owner || belongEmail,
                colleagueAccId,
                isTpMail,
                mailFrom,
                type,
                refId,
            });
        },
    },
    [MAIL_MENU_ITEM.REPLAY_ATTACH_ALL]: {
        key: MAIL_MENU_ITEM.REPLAY_ATTACH_ALL,
        name: getIn18Text('DAIFUJIANHUIFU'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'subordinate' && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== 'relatedEmail') {
                return false;
            }
            if ((mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz')
                return false;
            const { isThread } = mail;
            const { attachment } = mail.entry;
            const isShowAttachBtn = attachment && attachment.some(attach => !attach.inlined && attach.fileType !== 'ics');
            return !!isShowAttachBtn && !(getShowByFolder(mail, [FLOLDER.DRAFT]) || isCorpMail || isThread);
        },
        onClick: async (mails) => {
            const mail = getMailFromMails(mails);
            const ckRes = await replyPreCheck(mail);
            if (!ckRes)
                return;
            const { owner, mailFrom, tpMailInfo = {}, isTpMail } = mail;
            const { type, refId, colleagueAccId, belongEmail } = tpMailInfo || {};
            const _account = generateAcc(mail);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'replyAttachAll' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            setTimeout(() => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'replyAttachAll' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
            }, 500);
            return mailApi.doReplayMailWithAttach(getOperMailId(mail), true, undefined, undefined, _account, {
                owner: owner || belongEmail,
                colleagueAccId,
                isTpMail,
                mailFrom,
                type,
                refId,
            });
        },
    },
    [MAIL_MENU_ITEM.REPLAY_ALL_AS_NEW]: {
        key: MAIL_MENU_ITEM.REPLAY_ALL_AS_NEW,
        name: getIn18Text('HUIFUQUANBU(XYJ)'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        onClick: async (mails) => {
            const mail = getMailFromMails(mails);
            const ckRes = await replyPreCheck(mail);
            if (!ckRes)
                return;
            const { _account } = mail;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { opt: 'replyAllAsNew' },
                eventStrData: 'closeCurReadTab_before',
                _account,
            });
            setTimeout(() => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { opt: 'replyAllAsNew' },
                    eventStrData: 'closeCurReadTab_after',
                    _account,
                });
            }, 500);
            return mailApi.doReplayAllAsNew(getOperMailId(mail), undefined, _account);
        },
    },
    [MAIL_MENU_ITEM.DEFER]: {
        key: MAIL_MENU_ITEM.DEFER,
        name: mails => {
            const mail = getMailFromMails(mails);
            const { isDefer } = mail.entry;
            return !isDefer ? getIn18Text('SHAOHOUCHULI') : getIn18Text('BIAOWEIYICHULI');
        },
        show: mails => {
            var _a;
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            if (isCorpMail || mail.entry.isScheduleSend || (!taskMailMenuShow(mail) && ((_a = mail.taskInfo) === null || _a === void 0 ? void 0 : _a.status) === 0)) {
                return false;
            }
            return true;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { id, isDefer, deferTime, deferNotice } = mail.entry;
            const { _account } = mail;
            eventApi.sendSysEvent({
                eventName: 'mailStatesChanged',
                eventData: {
                    id,
                    isDefer,
                    deferTime,
                    deferNotice,
                },
                eventStrData: isDefer ? 'undefer' : 'defer',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.RED_FLAG]: {
        key: MAIL_MENU_ITEM.RED_FLAG,
        icon: mails => {
            const mail = getMailFromMails(mails);
            const { mark } = mail.entry;
            const isMark = mark == 'redFlag';
            return isMark ? React.createElement(ReadListIcons.RedFlagSvg, null) : React.createElement(ReadListIcons.FlagSvg_Cof, null);
        },
        name: mails => {
            if (Array.isArray(mails)) {
                const flagList = mails === null || mails === void 0 ? void 0 : mails.filter(item => {
                    if (item && item.entry) {
                        return item.entry.mark == 'redFlag';
                    }
                    return false;
                });
                return (mails === null || mails === void 0 ? void 0 : mails.length) === (flagList === null || flagList === void 0 ? void 0 : flagList.length) ? getIn18Text('QUXIAOHONGQI') : getIn18Text('BIAOWEIHONGQI');
            }
            else {
                const mail = getMailFromMails(mails);
                const { mark } = mail.entry;
                const isMark = mark == 'redFlag';
                return isMark ? getIn18Text('QUXIAOHONGQI') : getIn18Text('BIAOWEIHONGQI');
            }
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (isCorpMail && mail.entry.threadMessageIds && mail.entry.threadMessageIds.length > 1) {
                return false;
            }
            if (getShowByFolder(mail, [FLOLDER.DELETED, FLOLDER.SPAM, FLOLDER.ADVITISE])) {
                return false;
            }
            return true;
        },
        onClick: mails => {
            var _a, _b;
            if (Array.isArray(mails)) {
                const accountList = getMailListAccount(mails);
                if (accountList.length > 1) {
                    const flagList = mails === null || mails === void 0 ? void 0 : mails.filter(item => item.entry.mark == 'redFlag');
                    const redFlaged = (mails === null || mails === void 0 ? void 0 : mails.length) == (flagList === null || flagList === void 0 ? void 0 : flagList.length);
                    if (mails.length) {
                        const account2MailIdsMap = mailListSortByAccountToId(mails);
                        eventApi.sendSysEvent({
                            eventName: 'mailStatesChanged',
                            eventData: {
                                mark: !redFlaged,
                                map: account2MailIdsMap,
                            },
                            _account: mails && ((_a = mails[0]) === null || _a === void 0 ? void 0 : _a._account),
                            eventStrData: 'bulkMark',
                        });
                    }
                }
                else {
                    const flagList = mails === null || mails === void 0 ? void 0 : mails.filter(item => item.entry.mark == 'redFlag');
                    const redFlaged = (mails === null || mails === void 0 ? void 0 : mails.length) == (flagList === null || flagList === void 0 ? void 0 : flagList.length);
                    if (mails.length) {
                        let ids = [];
                        mails === null || mails === void 0 ? void 0 : mails.map(item => {
                            if (isCorpMail) {
                                ids.push(...getCorpMessageIdsByMailItem(item));
                            }
                            else {
                                ids.push(item.entry.id);
                            }
                        });
                        ids = Array.from(new Set(ids));
                        eventApi.sendSysEvent({
                            eventName: 'mailStatesChanged',
                            eventData: {
                                mark: !redFlaged,
                                id: ids,
                                type: 'redFlag',
                            },
                            _account: mails && ((_b = mails[0]) === null || _b === void 0 ? void 0 : _b._account),
                            eventStrData: redFlaged ? 'mark' : 'unmark',
                        });
                    }
                }
            }
            else {
                const mail = getMailFromMails(mails);
                const { entry: { id, mark }, } = mail || { entry: {} };
                const isMark = mark == 'redFlag';
                const { _account } = mail;
                eventApi.sendSysEvent({
                    eventName: 'mailStatesChanged',
                    eventData: {
                        mark: !isMark,
                        id,
                        type: 'redFlag',
                    },
                    eventStrData: mark ? 'mark' : 'unmark',
                    _account,
                });
            }
        },
    },
    [MAIL_MENU_ITEM.READ]: {
        key: MAIL_MENU_ITEM.READ,
        name: mails => {
            if (Array.isArray(mails)) {
                const readList = mails === null || mails === void 0 ? void 0 : mails.filter(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.readStatus) == 'read'; });
                return (mails === null || mails === void 0 ? void 0 : mails.length) === (readList === null || readList === void 0 ? void 0 : readList.length) ? getIn18Text('BIAOWEIWEIDU') : getIn18Text('BIAOWEIYIDU');
            }
            else {
                const mail = getMailFromMails(mails);
                const isRead = mail.entry.readStatus == 'read';
                return isRead ? getIn18Text('BIAOWEIWEIDU') : getIn18Text('BIAOWEIYIDU');
            }
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            const { isThread } = mail;
            if (isCorpMail && mail.entry.threadMessageIds && mail.entry.threadMessageIds.length > 1) {
                return false;
            }
            if (isThread || !getShowByFolder(mail, [FLOLDER.DELETED, FLOLDER.SPAM, FLOLDER.DRAFT, FLOLDER.SENT])) {
                return true;
            }
            return false;
        },
        onClick: mails => {
            var _a;
            if (Array.isArray(mails)) {
                const accountList = getMailListAccount(mails);
                if (accountList.length > 1) {
                    const readList = mails === null || mails === void 0 ? void 0 : mails.filter(item => item.entry.readStatus == 'read');
                    const readed = (mails === null || mails === void 0 ? void 0 : mails.length) == (readList === null || readList === void 0 ? void 0 : readList.length);
                    if (mails.length) {
                        const account2MailIdsMap = mailListSortByAccountToId(mails);
                        eventApi.sendSysEvent({
                            eventName: 'mailStatesChanged',
                            eventData: {
                                map: account2MailIdsMap,
                                mark: !readed,
                            },
                            eventStrData: 'bulkRead',
                            _account: '',
                        });
                    }
                }
                else {
                    const readList = mails === null || mails === void 0 ? void 0 : mails.filter(item => item.entry.readStatus == 'read');
                    const readed = (mails === null || mails === void 0 ? void 0 : mails.length) == (readList === null || readList === void 0 ? void 0 : readList.length);
                    if (mails.length) {
                        let ids = [];
                        mails === null || mails === void 0 ? void 0 : mails.map(item => {
                            if (isCorpMail) {
                                ids.push(...getCorpMessageIdsByMailItem(item));
                            }
                            else {
                                ids.push(item.entry.id);
                            }
                        });
                        ids = Array.from(new Set(ids));
                        eventApi.sendSysEvent({
                            eventName: 'mailStatesChanged',
                            eventData: {
                                mark: !readed,
                                id: ids,
                                type: 'read',
                            },
                            _account: mails && ((_a = mails[0]) === null || _a === void 0 ? void 0 : _a._account),
                            eventStrData: !readed ? 'read' : 'unread',
                        });
                    }
                }
            }
            else {
                const mail = getMailFromMails(mails);
                const isRead = mail.entry.readStatus == 'read';
                const { _account } = mail;
                eventApi.sendSysEvent({
                    eventName: 'mailStatesChanged',
                    eventData: {
                        mark: !isRead,
                        id: mail.entry.id,
                        type: 'read',
                    },
                    eventStrData: !isRead ? 'read' : 'unread',
                    _account,
                });
            }
        },
    },
    [MAIL_MENU_ITEM.TAG]: {
        key: MAIL_MENU_ITEM.TAG,
        name: getIn18Text('DABIAOQIAN'),
        icon: React.createElement(ReadListIcons.TagSvg_Cof, null),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (isCorpMail || getShowByFolder(mail, [FLOLDER.DRAFT, FLOLDER.SPAM, FLOLDER.ADVITISE, FLOLDER.DELETED])) {
                return false;
            }
            return true;
        },
        subMenus: (mails, onMenuClick) => {
            var _a;
            return (React.createElement("div", null,
                React.createElement(MailTagMenu, { mailList: Array.isArray(mails) ? mails : [mails], Close: () => onMenuClick && onMenuClick(false), account: Array.isArray(mails) ? (_a = mails[0]) === null || _a === void 0 ? void 0 : _a._account : mails === null || mails === void 0 ? void 0 : mails._account })));
        },
    },
    [MAIL_MENU_ITEM.TOP]: {
        key: MAIL_MENU_ITEM.TOP,
        name: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { id, top }, } = mail || { entry: {} };
            let showTop = top;
            if (Array.isArray(mails)) {
                showTop = !(mails === null || mails === void 0 ? void 0 : mails.some(item => !item.entry.top));
            }
            return showTop ? getIn18Text('QUXIAOZHIDING') : getIn18Text('ZHIDING');
        },
        icon: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { id, top }, } = mail || { entry: {} };
            return top ? React.createElement(ReadListIcons.MailUnTopSvg, null) : React.createElement(ReadListIcons.MailTopSvg, null);
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            if (getShowByFolder(mail, [FLOLDER.REDFLAG, FLOLDER.UNREAD, FLOLDER.DELETED, FLOLDER.SPAM, FLOLDER.ADVITISE, FLOLDER.DRAFT, FLOLDER.DEFER])) {
                return false;
            }
            return true;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { id, top }, isThread = false, _account, } = mail || { entry: {} };
            let ids = [id];
            if (Array.isArray(mails)) {
                ids = mails === null || mails === void 0 ? void 0 : mails.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; });
            }
            let showTop = top;
            if (Array.isArray(mails)) {
                showTop = !(mails === null || mails === void 0 ? void 0 : mails.some(item => !item.entry.top));
            }
            eventApi.sendSysEvent({
                eventName: 'mailStatesChanged',
                eventData: {
                    mark: !showTop,
                    id: ids,
                    isThread,
                },
                _account,
                eventStrData: !top ? 'top' : 'unTop',
            });
        },
    },
    [MAIL_MENU_ITEM.COMMENT]: {
        key: MAIL_MENU_ITEM.COMMENT,
        name: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { memo }, } = mail || { entry: {} };
            return memo ? getIn18Text('XIUGAIBEIZHU') : getIn18Text('BEIZHU');
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (isThread) {
                return false;
            }
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return true;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { memo }, isThread = false, _account, } = mail || { entry: {} };
            const { id } = mail.entry;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    memo,
                    mailId: id,
                    accountId: _account,
                },
                _account,
                eventStrData: 'comment',
            });
        },
    },
    [MAIL_MENU_ITEM.MOVE]: {
        key: MAIL_MENU_ITEM.MOVE,
        name: getIn18Text('YIDONG'),
        icon: React.createElement(ReadListIcons.MoveSvg_Cof, null),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT, FLOLDER.WAITINGISSUE, FLOLDER.READYISSUE]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { id, folder } = mail.entry;
            const { _account } = mail;
            const ids = Array.isArray(mails) ? mails.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }) : id;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailId: ids,
                    folderId: folder,
                    accountId: _account,
                },
                _account,
                eventStrData: 'move',
            });
        },
    },
    [MAIL_MENU_ITEM.REPORT]: {
        key: MAIL_MENU_ITEM.REPORT,
        name: getIn18Text('JUBAO'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            return !isCorpMail && !mail.isThread && !getShowByFolder(mail, [FLOLDER.DRAFT, FLOLDER.SENT]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { id, folder }, isThread = false, _account, } = mail || { entry: {} };
            const senderEmail = get(mail, ['sender', 'contactItem', 'contactItemVal'], '');
            const hasReport = false;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailId: id,
                    hasReport,
                    senderEmail,
                },
                eventStrData: 'report',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.REPORT_TRUST]: {
        key: MAIL_MENU_ITEM.REPORT_TRUST,
        name: getIn18Text('XINREN'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            return !isCorpMail && !mail.isThread && !getShowByFolder(mail, [FLOLDER.DRAFT]) && getShowByFolder(mail, [FLOLDER.SPAM]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { id, folder }, isThread = false, _account, } = mail || { entry: {} };
            const senderEmail = get(mail, ['sender', 'contactItem', 'contactItemVal'], '');
            const hasReport = true;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailId: id,
                    hasReport,
                    senderEmail,
                },
                eventStrData: 'report',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.DELETE]: {
        key: MAIL_MENU_ITEM.DELETE,
        icon: React.createElement(ReadListIcons.RecycleSvg_Cof, null),
        name: mails => {
            const mail = getMailFromMails(mails);
            if (getShowByFolder(mail, [FLOLDER.DELETED])) {
                return getIn18Text('CHEDISHANCHU');
            }
            return getIn18Text('SHANCHU');
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return true;
        },
        onClick: async (mails) => {
            var _a, _b;
            const mail = getMailFromMails(mails);
            const bandExport = await mailConfApi.getAccountBanSetting(mail === null || mail === void 0 ? void 0 : mail._account).then(res => res.ban_del_mail);
            if (bandExport) {
                message.warn(getIn18Text('MEIYOUSHANCHUQUANXIAN，'));
                return;
            }
            if (Array.isArray(mails)) {
                const accountList = getMailListAccount(mails);
                if (accountList.length > 1) {
                    const account2MailIdsMap = mailListSortByAccountToId(mails);
                    let hasDeleted = false;
                    let hasScheduleSend = false;
                    let fid = mails[0] && ((_b = (_a = mails[0]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.folder);
                    const ids = mails.map(item => {
                        var _a, _b, _c;
                        if ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.isScheduleSend) {
                            hasScheduleSend = true;
                        }
                        if (((_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.folder) === FLOLDER.DELETED) {
                            hasDeleted = true;
                        }
                        return (_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.id;
                    });
                    const params = {
                        detail: hasDeleted,
                        showGlobalLoading: false,
                        showLoading: true,
                        isScheduleSend: !!hasScheduleSend,
                    };
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            params,
                            map: account2MailIdsMap,
                            fid: fid,
                            directDelete: getShowByFolder(mail, [FLOLDER.DELETED]),
                        },
                        eventStrData: 'bulkDelete',
                        _account: '',
                    });
                }
                else {
                    const mail = getMailFromMails(mails);
                    const { isThread, _account } = mail;
                    const { folder } = mail.entry;
                    let hasScheduleSend = false;
                    const ids = mails.map(item => {
                        var _a, _b;
                        if ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.isScheduleSend) {
                            hasScheduleSend = true;
                        }
                        return (_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.id;
                    });
                    const params = {
                        detail: folder === FLOLDER.DELETED,
                        showLoading: true,
                        isScheduleSend: !isThread && !!hasScheduleSend,
                        directDelete: getShowByFolder(mail, [FLOLDER.DELETED]),
                    };
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            mailId: ids,
                            isThread,
                            params,
                            folderId: folder,
                        },
                        eventStrData: 'delete',
                        _account,
                    });
                }
            }
            else {
                const { isThread, _account } = mail;
                const { id, folder, isScheduleSend } = mail.entry;
                const params = {
                    detail: folder === FLOLDER.DELETED,
                    showGlobalLoading: isThread,
                    showLoading: true,
                    isScheduleSend: !isThread && !!isScheduleSend,
                };
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: {
                        mailId: id,
                        isThread,
                        params,
                        folderId: folder,
                        directDelete: getShowByFolder(mail, [FLOLDER.DELETED]),
                    },
                    eventStrData: 'delete',
                    _account,
                });
            }
        },
    },
    [MAIL_MENU_ITEM.DIRECT_DELETE]: {
        key: MAIL_MENU_ITEM.DIRECT_DELETE,
        icon: React.createElement(ReadListIcons.RecycleSvg_Cof, null),
        name: mails => {
            return getIn18Text('CHEDISHANCHU');
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (getShowByFolder(mail, [FLOLDER.ADVITISE, FLOLDER.SPAM])) {
                return true;
            }
            return false;
        },
        onClick: async (mails) => {
            var _a, _b;
            const mail = getMailFromMails(mails);
            const bandExport = await mailConfApi.getAccountBanSetting(mail === null || mail === void 0 ? void 0 : mail._account).then(res => res.ban_del_mail);
            if (bandExport) {
                message.warn(getIn18Text('MEIYOUSHANCHUQUANXIAN，'));
                return;
            }
            if (Array.isArray(mails)) {
                const accountList = getMailListAccount(mails);
                if (accountList.length > 1) {
                    const account2MailIdsMap = mailListSortByAccountToId(mails);
                    let hasScheduleSend = false;
                    let fid = mails[0] && ((_b = (_a = mails[0]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.folder);
                    const ids = mails.map(item => {
                        var _a, _b;
                        if ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.isScheduleSend) {
                            hasScheduleSend = true;
                        }
                        return (_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.id;
                    });
                    const params = {
                        detail: true,
                        showGlobalLoading: false,
                        showLoading: true,
                        isScheduleSend: !!hasScheduleSend,
                        directDelete: true,
                    };
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            params,
                            map: account2MailIdsMap,
                            fid: fid,
                        },
                        eventStrData: 'bulkDelete',
                        _account: '',
                    });
                }
                else {
                    const mail = getMailFromMails(mails);
                    const { isThread, _account } = mail;
                    const { folder } = mail.entry;
                    let hasScheduleSend = false;
                    const ids = mails.map(item => {
                        var _a, _b;
                        if ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.isScheduleSend) {
                            hasScheduleSend = true;
                        }
                        return (_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.id;
                    });
                    const params = {
                        detail: true,
                        showGlobalLoading: isThread,
                        showLoading: true,
                        isScheduleSend: !isThread && !!hasScheduleSend,
                        directDelete: true,
                    };
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            mailId: ids,
                            isThread,
                            params,
                            folderId: folder,
                        },
                        eventStrData: 'delete',
                        _account,
                    });
                }
            }
            else {
                const { isThread, _account } = mail;
                const { id, folder, isScheduleSend } = mail.entry;
                const params = {
                    detail: true,
                    showGlobalLoading: isThread,
                    showLoading: true,
                    isScheduleSend: !isThread && !!isScheduleSend,
                    directDelete: true,
                };
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: {
                        mailId: id,
                        isThread,
                        params,
                        folderId: folder,
                    },
                    eventStrData: 'delete',
                    _account,
                });
            }
        },
    },
    [MAIL_MENU_ITEM.SHARE]: {
        key: MAIL_MENU_ITEM.SHARE,
        name: getIn18Text('FENXIANGDAOHUIHUA'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            const { isThread, entry, _account } = mail;
            const excludeFolders = [FLOLDER.SPAM, FLOLDER.DRAFT, FLOLDER.DELETED, FLOLDER.ADVITISE];
            const { folder } = entry;
            return !isThread && !excludeFolders.includes(folder) && nimApi.getIMAuthConfig();
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { _account } = mail;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: mail,
                eventStrData: 'share',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.TRANSLATE]: {
        key: MAIL_MENU_ITEM.TRANSLATE,
        name: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { langType }, } = mail || { entry: {} };
            return langType !== '' && langType !== 'origin' ? getIn18Text('QUXIAOFANYI') : getIn18Text('FANYI');
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            const { folder } = mail.entry;
            return (folder != FLOLDER.DRAFT && !isCorpMail) || !isThread;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { entry: { langType, id }, _account, isEncryptedMail, } = mail || { entry: {}, isEncryptedMail: false };
            if (isEncryptedMail) {
                Toast.info({ content: getIn18Text('JIAMIYOUJIANZANBZCFY') });
                return;
            }
            eventApi.sendSysEvent({
                eventName: 'mailTranslateChanged',
                eventData: {
                    type: 'translate',
                    id,
                },
                eventStrData: langType !== '' && langType !== 'origin' ? 'cancelTranslate' : 'translate',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.SEARCH_IN_CONTENT]: {
        key: MAIL_MENU_ITEM.SEARCH_IN_CONTENT,
        tip: mails => (isMac() ? '⌘F' : 'Ctrl+F'),
        name: getIn18Text('SOUSUOZHENWENNEIRONG'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return true;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            if (mail.isEncryptedMail) {
                Toast.info({ content: getIn18Text('JIAMIYOUJIANZANBZCZWSS') });
                return;
            }
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventStrData: 'searchInContent',
            });
        },
    },
    [MAIL_MENU_ITEM.OPEN_IN_WINDOW]: {
        key: MAIL_MENU_ITEM.OPEN_IN_WINDOW,
        tip: mail => (isMac() ? '⌘R' : 'Ctrl+R'),
        name: getIn18Text('XINCHUANGKOUDAKAI'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return !isCorpMail;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            openMailInWinow(mail);
        },
    },
    [MAIL_MENU_ITEM.SET_FROM_GROUP]: {
        key: MAIL_MENU_ITEM.SET_FROM_GROUP,
        group: '5',
        name: getIn18Text('SHEZHILAIXINFEN'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (mail.isThread) {
                return false;
            }
            if (isCorpMail)
                return false;
            const { taskInfo } = mail;
            return systemApi.isMainPage() && (taskInfo === null || taskInfo === void 0 ? void 0 : taskInfo.status) !== TASK_MAIL_STATUS.PROCESSING;
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { isThread, _account } = mail;
            const { id, folder, title } = mail.entry;
            const eventData = {
                title,
            };
            const senderEmail = get(mail, ['sender', 'contactItem', 'contactItemVal'], '');
            if (!isThread) {
                eventData.senderEmail = senderEmail;
            }
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData,
                eventStrData: 'setFromGroup',
                _account,
            });
            trackApi.track('pcMail_view_mailClassificationNewPage', { type: 'singleMail' });
        },
    },
    [MAIL_MENU_ITEM.EXPORT]: {
        key: MAIL_MENU_ITEM.EXPORT,
        name: mails => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            return isThread ? getIn18Text('DAOCHUJUHEYOU') : getIn18Text('DAOCHUYOUJIAN');
        },
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return !isCorpMail;
        },
        onClick: async (mails) => {
            var _a, _b, _c, _d;
            if (Array.isArray(mails)) {
                if (mails.length > MAIL_EXPORT_LIMIT) {
                    message.error(getIn18Text('DAOCHUSHULIANGCHAO1', { count: MAIL_EXPORT_LIMIT }));
                    return;
                }
                const isThreadMails = mails.length ? !!mails[0].isThread : false;
                const ids = mails.map(mail => mail.id || mail.entry.id);
                const title = mails.length === 1 ? (_b = (_a = mails[0]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.title : '';
                const account = (_c = mails[0]) === null || _c === void 0 ? void 0 : _c._account;
                const bandExport = await mailConfApi.getAccountBanSetting((_d = mails[0]) === null || _d === void 0 ? void 0 : _d._account).then(res => res.ban_export_mail);
                if (bandExport) {
                    message.warn(getIn18Text('MEIYOUDAOCHUQUANX，QLXGLY'));
                    return;
                }
                mailApi
                    .doExportMail(ids, isThreadMails, title, window.isInOtherApp ? '' : getIn18Text('YOUJIANDAOCHUZHONG'), account)
                    .then(res => {
                    var _a, _b;
                    if (((_a = res) === null || _a === void 0 ? void 0 : _a.succ) || ((_b = res) === null || _b === void 0 ? void 0 : _b.success)) {
                        if (!window.isInOtherApp) {
                            message.success({ content: getIn18Text('YOUJIANDAOCHUCHENG') });
                        }
                    }
                    else {
                        message.error({ content: getIn18Text('YOUJIANDAOCHUSHI') });
                    }
                })
                    .catch(e => {
                    console.error('[mail export error]', e);
                    message.error({ content: e.message });
                });
            }
            else {
                const mail = getMailFromMails(mails);
                const { _account, isEncryptedMail } = mail;
                const bandExport = await mailConfApi.getAccountBanSetting(_account).then(res => res.ban_export_mail);
                if (bandExport) {
                    message.warn(getIn18Text('MEIYOUDAOCHUQUANX，QLXGLY'));
                    return;
                }
                if (isEncryptedMail) {
                    Toast.info({ content: getIn18Text('JIAMIYOUJIANZANBZCDC') });
                    return;
                }
                const { id, title } = mail.entry;
                const isThreadMail = !!mail.isThread;
                mailApi
                    .doExportMail(id, isThreadMail, title, window.isInOtherApp ? '' : getIn18Text('YOUJIANDAOCHUZHONG'), _account)
                    .then(res => {
                    var _a, _b;
                    (((_a = res) === null || _a === void 0 ? void 0 : _a.succ) || ((_b = res) === null || _b === void 0 ? void 0 : _b.success)) && !window.isInOtherApp && message.success({ content: getIn18Text('YOUJIANDAOCHUCHENG') });
                })
                    .catch(e => {
                    console.error('[mail export error]', e);
                    message.error({ content: '导出失败' });
                });
            }
        },
    },
    [MAIL_MENU_ITEM.ENCODING]: {
        key: MAIL_MENU_ITEM.ENCODING,
        name: getIn18Text('XUANZEBIANMA'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (mail.isThread) {
                return false;
            }
            if (isCorpMail)
                return false;
            return true;
        },
        subMenus: (mails, onMenuClick) => {
            const mail = getMailFromMails(mails);
            return (React.createElement("div", null,
                React.createElement(MailEncoding, { disable: mail === null || mail === void 0 ? void 0 : mail.isEncryptedMail, disableTip: getIn18Text('JIAMIYOUJIANZANBZCXZBM'), mid: mail.entry.id, encodingValue: mail.entry.content.encoding, account: mail._account, close: () => onMenuClick && onMenuClick(false) })));
        },
    },
    [MAIL_MENU_ITEM.MAIL_WITHDRAW]: {
        key: MAIL_MENU_ITEM.MAIL_WITHDRAW,
        name: getIn18Text('CHEHUIYOUJIAN1'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            const { isThread } = mail;
            return getShowByFolder(mail, [FLOLDER.SENT]) && !isThread && permRecallMail();
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailData: mails,
                    showRes: false,
                },
                eventStrData: 'retractEmail',
                _account: mail === null || mail === void 0 ? void 0 : mail._account,
            });
        },
    },
    [MAIL_MENU_ITEM.MAIL_WITHDRAW_RES]: {
        key: MAIL_MENU_ITEM.MAIL_WITHDRAW_RES,
        name: getIn18Text('CHEHUIJIEGUO'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            const { isThread } = mail;
            return getShowByFolder(mail, [FLOLDER.SENT]) && !isThread && permRecallMail();
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailData: mails,
                    showRes: true,
                },
                eventStrData: 'retractEmail',
                _account: mail === null || mail === void 0 ? void 0 : mail._account,
            });
        },
    },
    [MAIL_MENU_ITEM.PRINT_MAIL_PREVIEW]: {
        key: MAIL_MENU_ITEM.PRINT_MAIL_PREVIEW,
        name: getIn18Text('PRINT_EMAIL_PREVIEW'),
        show: mails => {
            if (!process.env.BUILD_ISELECTRON)
                return false;
            return getShouldShowPrintByEmails(mails);
        },
        onClick: mails => {
            handleMailPrint(mails, true);
        },
    },
    [MAIL_MENU_ITEM.PRINT_MAIL]: {
        key: MAIL_MENU_ITEM.PRINT_MAIL,
        name: !process.env.BUILD_ISELECTRON ? getIn18Text('DAYINYOUJIAN') : getIn18Text('DAYIN'),
        show: mails => {
            return getShouldShowPrintByEmails(mails);
        },
        onClick: mails => {
            handleMailPrint(mails, false);
        },
    },
    [MAIL_MENU_ITEM.CREATE_PERSONAL_GROUP]: {
        key: MAIL_MENU_ITEM.CREATE_PERSONAL_GROUP,
        name: getIn18Text('XINJIANGERENFENZ'),
        show: mails => {
            var _a;
            const mail = getMailFromMails(mails);
            if (!isMainAccount(mail._account)) {
                return false;
            }
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            const { isThread } = mail;
            return !isThread && !!((_a = mail === null || mail === void 0 ? void 0 : mail.receiver) === null || _a === void 0 ? void 0 : _a.length);
        },
        onClick: mails => {
            var _a;
            const mail = getMailFromMails(mails);
            const { isThread, _account } = mail;
            const { id } = mail.entry;
            let receiverEmails = [];
            if (mail.receiver.length) {
                receiverEmails = (_a = mail.receiver) === null || _a === void 0 ? void 0 : _a.map(item => {
                    return {
                        name: item === null || item === void 0 ? void 0 : item.originName,
                        email: contactApi.doGetModelDisplayEmail(item.contact),
                    };
                });
            }
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailId: id,
                    receiverEmails,
                },
                eventStrData: 'createPersonalGroup',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.DISCUSSION]: {
        key: MAIL_MENU_ITEM.DISCUSSION,
        name: getIn18Text('YOUJIANTAOLUN'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            if (!isMainAccount(mail._account)) {
                return false;
            }
            const { isThread, entry, _account } = mail;
            const excludeFolders = [FLOLDER.SPAM, FLOLDER.DRAFT, FLOLDER.DELETED, FLOLDER.ADVITISE];
            const { folder } = entry;
            return !isThread && !excludeFolders.includes(folder) && nimApi.getIMAuthConfig();
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { isThread, _account } = mail;
            const { id, tid } = mail.entry;
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailId: id,
                    tid,
                },
                eventStrData: 'discussion',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.EMAIL_HEADER]: {
        key: MAIL_MENU_ITEM.EMAIL_HEADER,
        name: getIn18Text('CHAKANXINTOU'),
        show: mails => {
            const mail = getMailFromMails(mails);
            if ((mail === null || mail === void 0 ? void 0 : mail.isTpMail) || (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            const { isThread } = mail;
            return !isThread;
        },
        onClick: mails => { },
    },
    [MAIL_MENU_ITEM.WMFOLLOW]: {
        key: MAIL_MENU_ITEM.WMFOLLOW,
        icon: mails => {
            const mail = getMailFromMails(mails);
            const { isFollowUp } = mail.entry;
            return isFollowUp == null || isFollowUp ? (React.createElement("span", { className: "grey flag-icon" },
                React.createElement(ReadListIcons.FollowUp, null))) : (React.createElement("span", { className: "red" },
                React.createElement(ReadListIcons.UnFollowUp, null)));
        },
        name: mails => {
            const mail = getMailFromMails(mails);
            const { isFollowUp } = (mail === null || mail === void 0 ? void 0 : mail.entry) || {};
            return isFollowUp == null || isFollowUp ? getIn18Text('BIAOWEIDAIGJ') : getIn18Text('BIAOWEIYIGJ');
        },
        show: mails => {
            var _a;
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (!(process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) ||
                isThread ||
                (mail === null || mail === void 0 ? void 0 : mail.isTpMail) ||
                (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'subordinate' ||
                (mail === null || mail === void 0 ? void 0 : mail.mailFrom) === 'biz') {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DELETED, FLOLDER.DRAFT]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { id, folder, isFollowUp } = mail.entry;
            const { _account } = mail;
            const ids = Array.isArray(mails) ? mails.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }) : [id];
            const accounts = Array.isArray(mails) ? mails.map(item => item === null || item === void 0 ? void 0 : item._account) : [_account];
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    ids: ids,
                    accounts,
                    mark: !(isFollowUp == null || isFollowUp),
                },
                eventStrData: 'markProcessFollow',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.WMFOLLOW_STATIC]: {
        key: MAIL_MENU_ITEM.WMFOLLOW_STATIC,
        icon: mails => {
            return (React.createElement("span", { className: "red" },
                React.createElement(ReadListIcons.UnFollowUp, null)));
        },
        name: mails => {
            return getIn18Text('BIAOWEIYIGJ');
        },
        show: mails => {
            var _a;
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (!(process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) || isThread) {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DELETED, FLOLDER.DRAFT]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { id, folder, isFollowUp } = mail.entry;
            const { _account } = mail;
            const ids = Array.isArray(mails) ? mails.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }) : [id];
            const accounts = Array.isArray(mails) ? mails.map(item => item === null || item === void 0 ? void 0 : item._account) : [_account];
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    ids: ids,
                    accounts,
                    mark: true,
                },
                eventStrData: 'markProcessFollow',
                _account,
            });
        },
    },
    [MAIL_MENU_ITEM.WM_UNFOLLOW_STATIC]: {
        key: MAIL_MENU_ITEM.WM_UNFOLLOW_STATIC,
        icon: mails => {
            return (React.createElement("span", { className: "grey flag-icon" },
                React.createElement(ReadListIcons.FollowUp, null)));
        },
        name: mails => {
            return getIn18Text('BIAOWEIDAIGJ');
        },
        show: mails => {
            var _a;
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (!(process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) || isThread) {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DELETED, FLOLDER.DRAFT]);
        },
        onClick: mails => {
            const mail = getMailFromMails(mails);
            const { id, folder, isFollowUp } = mail.entry;
            const { _account } = mail;
            const ids = Array.isArray(mails) ? mails.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }) : [id];
            const accounts = Array.isArray(mails) ? mails.map(item => item === null || item === void 0 ? void 0 : item._account) : [_account];
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    ids: ids,
                    accounts,
                    mark: false,
                },
                eventStrData: 'markProcessFollow',
                _account,
            });
        },
    },
};
export default DefaultMailMenuConfig;
